import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=716e29f7&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=716e29f7&lang=scss"
import "./App.vue?vue&type=style&index=2&id=716e29f7&lang=css"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716e29f7"]])

export default __exports__